module.exports = __webpack_public_path__ + "static/img/mica-3.0a14807.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/mica-3.jpg
// module id = Os4t
// module chunks = 1